import React, { FC } from "react";
import NumberFormat from "react-number-format";

import ErrorBar from "components/ErrorBar";

import styles from "./styles.module.scss";

type Props = {
  onChange(newValue?: string): void;
  disabled?: boolean;
  error?: string;
  value: string;
  id?: string;
  showErrors?: boolean;
  placeholder?: string;
};

const AmountField: FC<Props> = ({
  onChange,
  disabled,
  error,
  value,
  id,
  showErrors,
  placeholder,
}) => {
  return (
    <div className={styles.container}>
      <NumberFormat
        allowNegative
        id={id}
        className={styles.field}
        placeholder={placeholder || "$0.00"}
        value={value}
        prefix="$"
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        disabled={disabled}
        onValueChange={({ value: newValue }) => {
          if (!newValue) onChange(undefined);
          else onChange(newValue);
        }}
      />
      {showErrors && <ErrorBar id={id} error={error} />}
    </div>
  );
};

AmountField.defaultProps = {
  disabled: false,
  error: undefined,
  id: undefined,
  showErrors: false,
  placeholder: undefined,
};

export default AmountField;
